<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Проверьте правильность введенных данных
        </div>
        <div
          class="body-info__block double">
          <div
            class="info-title">
            Данные об устройстве
            <span
              class="text">
              Для изменения обратитесь в чат тех. поддержки
            </span>
          </div>
          <div
            class="info-table">
            <div
              v-if="model.imei"
              class="info-table__line">
              <div
                class="label">
                IMEI
              </div>
              <div
                class="value">
                {{ model.imei }}
              </div>
            </div>
            <div
              class="info-table__line"
              v-for="(item, i) in model.mobile" :key="i"
              v-if="arrayName.find(item => item.key === i)">
              <div
                class="label">
                {{ arrayName.find(item => item.key === i).name }}
              </div>
              <div
                class="value">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="body-info__block double">
          <div
            class="info-title">
            Данные о клиенте
            <button
              type="button"
              class="btn next"
              @click.prevent="changeInfo()">
              Изменить
            </button>
          </div>
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">
                ФИО
              </div>
              <div
                class="value">
                {{ clientInfo.lastname }} {{ clientInfo.firstname }} {{ clientInfo.patronymic }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Телефон
              </div>
              <div
                class="value">
                {{ clientInfo.telefon }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="next()">
        Подписать договор
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  props: ['user'],
  data() {
    return {
      arrayName: [
        { key: 'IMEI', name: 'IMEI' },
        { key: 'SerialNumber', name: 'Серийный номер' },
        { key: 'ModelName', name: 'Модель' },
        { key: 'Capacity', name: 'Объем' },
        // { key: 'Color', name: 'Цвет' },
        { key: 'manufactorer', name: 'Производитель' },
        { key: 'model', name: 'Модель' },
      ],
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'clientInfo']),
  },
  methods: {
    ...mapActions('buyphones', ['updateOrder','sendSms']),
    ...mapMutations('buyphones', ['CHANGE_SCREEN_THREE']),

    changeInfo() {
      this.CHANGE_SCREEN_THREE({ show2: true, show3: false, show4: false });
    },
    async next() {
      
      await this.updateOrder({
        btag: this.model.btag,
        data: {
          client: {
            name: this.clientInfo.lastname + ' ' + this.clientInfo.firstname + ' ' + this.clientInfo.patronymic,
            phone: this.clientInfo.telefon.replace(/\+/g, ''),
          }
        }
      });
      var sendData = {
        "contractId": this.model.btag,
        "phoneNumber": this.clientInfo.telefon
      }
      await this.sendSms(sendData)
      this.CHANGE_SCREEN_THREE({ show2: false, show3: false, show4: true });
    },
  }
}
</script>

<style lang="css">
</style>
